import { hoistStatics, withProps } from 'react-recompose';

import {
  MOUNT_NODE,
  MOUNT_NODE_ALT,
  HUBS_ROOT_NODE_CLASS_NAME,
  FCSUI_CLASS_NAME,
} from '../constants';

// Render a SUIR modal or popup into a designated DIV using the `mountNode` property.
// This allows us to render the markup for modal and popups into the React application root node hierarchy, thus
// allowing us to scope CSS rules based on classes set on that element. In such a scenario, the application should
// render such a DIV
export const withMountNode = (component, alternative) =>
  hoistStatics(
    withProps(() => ({
      mountNode:
        document.getElementById(alternative ? MOUNT_NODE_ALT : MOUNT_NODE) ||
        document.body,
    })),
  )(component);

// This is necessary in order to provide modals with an outlet outside of the Naviance Student application root ("#root").
// It must be outside for accessibility purposes. Notably, to allow the main content of the application to have its
// aria-hidden property switched on/off independently of the modal content.
export function setupMountNode(alternative) {
  const matchContainerSelector = `body > .${HUBS_ROOT_NODE_CLASS_NAME} `;

  const mountNode = alternative ? MOUNT_NODE_ALT : MOUNT_NODE;

  /* istanbul ignore else */
  if (!document.querySelector(matchContainerSelector)) {
    const modalContainer = document.createElement('div');
    // Using this class allows the modal to inherit the appropriate styles despite being located outside of the main active-match DOM tree
    modalContainer.className = `${HUBS_ROOT_NODE_CLASS_NAME} ${FCSUI_CLASS_NAME}`;
    document.body.appendChild(modalContainer);
  }

  /* istanbul ignore else */
  if (!document.querySelector(`${matchContainerSelector} > #${mountNode}`)) {
    const modalContainer = document.querySelector(matchContainerSelector);
    const mountContainer = document.createElement('div');
    mountContainer.id = mountNode;
    modalContainer.appendChild(mountContainer);
  }

  const cleanupMountNode = () => {
    const modalContainer = document.querySelector(matchContainerSelector);
    /* istanbul ignore else */
    if (modalContainer) {
      document.body.removeChild(modalContainer);
    }
  };

  return cleanupMountNode;
}
